import { render, staticRenderFns } from "./CustomerFinancialProposalTable.vue?vue&type=template&id=3843425e&scoped=true"
import script from "./CustomerFinancialProposalTable.vue?vue&type=script&lang=js"
export * from "./CustomerFinancialProposalTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerFinancialProposalTable.vue?vue&type=style&index=0&id=3843425e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843425e",
  null
  
)

export default component.exports